import React from 'react'
import { Route } from 'react-router-dom'
import AuthorizedComponent from 'src/components/Auth/AuthorizedComponent'
import Exports from 'src/modules/Exports'

const route = <Route path="/exports" element={<AuthorizedComponent component={Exports} />} />

export default route
